import { getToken } from "./user-service";
import axios from "axios";

/**
 * Get flight events / airport updates
 *
 * @param {Object} params - Query parameters
 * @param {string} params.iata - Airport IATA code
 * @param {string} params.startTime - Start datetime in ISO format (e.g., 2026-01-20T00:00:00.000Z)
 * @param {string} params.endTime - End datetime in ISO format (e.g., 2026-01-20T23:59:59.999Z)
 * @returns {Promise<Array>} Array of flight events
 */
export const getFlightEvents = async (params) => {
    const token = await getToken();

    // Build query string
    const queryParams = new URLSearchParams({
        iata: params.iata,
        startTime: params.startTime,
        endTime: params.endTime,
    });

    // API Gateway routes /api/v1/flights to prm-flights-service
    const url = `/api/v1/flights/flight-events/airport-updates?${queryParams.toString()}`;

    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.get(url, {
                headers: { 
                    "Firebase-UID": token,
                    "Accept": "application/json"
                },
            });

            if (response.status >= 400 && response.status < 600) {
                throw new Error("Issue getting flight events");
            }

            resolve(response.data);
        } catch (e) {
            reject(new Error("error getting flight events"));
        }
    });
};
